<ng-content></ng-content>
<input #fileInput class="file-input" (change)="onChanged($event)" type="file" [accept]="fileExtensions?.join(', ')" />
